var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NoticeMessage'),_vm._v(" "),(_vm.isLoaded)?_c('FlashMessages',{attrs:{"context":_vm.context}}):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('OverlayLoader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }